import { GAME_CONSTANTS } from '../../config/constants.js';
import { EventBus }       from '../../core/EventBus.js';

/**
 * Manages toast notifications in #notification-container.
 */
export class NotificationToast {
  constructor() {
    this.queue = [];
  }

  init() {
    EventBus.on('ui:notification',       (d) => this.show(d.message, d.type));
    EventBus.on('player:moneyChanged',   (d) => {
      if (d.reason) this.show(d.reason, d.amount >= 0 ? 'success' : 'warning');
    });
    EventBus.on('ship:arrived',          (d) => this.show(`${d.ship.name} arrived at ${d.port?.name || 'port'}`, 'info'));
    EventBus.on('contract:completed',    (d) => this.show(`Contract completed! +$${d.payment.toLocaleString()}`, 'success'));
    EventBus.on('contract:failed',       (d) => this.show(`Contract failed – deadline missed.`, 'error'));
    EventBus.on('contract:failedBatch', (d) => this.show(`${d.count} contracts failed – deadlines missed.`, 'error'));
    EventBus.on('ship:fuelLow',          (d) => this.show(`Warning: ${d.ship.name} fuel is low!`, 'warning'));
    EventBus.on('ship:stranded',         (d) => this.show(`${d.ship.name} has run out of fuel!`, 'error'));
    EventBus.on('research:completed',    (d) => this.show(`Research complete: ${d.research.name}`, 'success'));
    EventBus.on('permit:completed',     (d) => this.show(`Permit granted: ${d.permit.name}`, 'success'));
    EventBus.on('permit:bribeFailed',   (d) => this.show(`Expedite failed! Fined ${d.fine.toLocaleString()}`, 'error'));
    EventBus.on('player:milestone',      (d) => this.show(`Milestone unlocked: ${d.milestone.name}!`, 'success'));
  }

  /** Show a toast. type: info | success | warning | error */
  show(message, type = 'info') {
    if (this.queue.length >= GAME_CONSTANTS.MAX_NOTIFICATION_QUEUE) {
      // Remove oldest
      const oldest = this.queue.shift();
      if (oldest) {
        clearTimeout(oldest.timeout);
        oldest.el.remove();
      }
    }

    const el = document.createElement('div');
    el.className = `toast toast-${type}`;
    el.textContent = message;
    document.getElementById('notification-container').appendChild(el);

    // Trigger animation
    requestAnimationFrame(() => el.classList.add('visible'));

    const timeout = setTimeout(() => {
      el.classList.remove('visible');
      setTimeout(() => el.remove(), 300);
      const idx = this.queue.indexOf(entry);
      if (idx > -1) this.queue.splice(idx, 1);
    }, GAME_CONSTANTS.NOTIFICATION_DURATION_MS);

    const entry = { el, timeout };
    this.queue.push(entry);
  }
}
